import React, { Fragment, useState, useContext, useEffect } from "react";
import {
  Grid,
  Typography,
  Divider,
  ButtonGroup,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import StarIcon from "@material-ui/icons/Star";

import DashboardContext from "../../../context/dashboard/DashboardContext";

const TopProducts = () => {
  const dashboardContext = useContext(DashboardContext);
  const { getDashboardTopProducts, products } = dashboardContext;
  const [loading, setLoading] = useState(false);
  const [daySelected, setDaySelected] = useState("Today");
  const [dayButtonColor, setDayButtonColor] = useState({
    todayBG: "#ffffff",
    todayText: "normal",
    yesterdayBG: "#ffffff",
    yesterdayText: "normal",
  });

  useEffect(() => {
    if (daySelected) {
      if (daySelected === "Today") {
        setDayButtonColor({
          todayBG: "#dddddd",
          todayText: "bold",
          yesterdayBG: "#ffffff",
          yesterdayText: "normal",
        });
      } else if (daySelected === "Yesterday") {
        setDayButtonColor({
          todayBG: "#ffffff",
          todayText: "normal",
          yesterdayBG: "#dddddd",
          yesterdayText: "bold",
        });
      }
    }
  }, [daySelected]);

  const useStyles = makeStyles((theme) => ({
    headerText: {
      color: theme.palette.primary.contrastText,
    },
    buttonOutline: {
      "&:focus": {
        outline: "none",
      },
    },
    bgColor: {
      backgroundColor: theme.palette.primary.dark,
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    var from = "";
    var to = "";
    setLoading(true);
    if (daySelected === "Today") {
      from = new Date(new Date().setHours(8, 0, 0, 0)).toISOString();
      to = new Date(new Date().setHours(32, 0, 0, 0)).toISOString();
    } else if (daySelected === "Yesterday") {
      from = new Date(new Date().setHours(-16, 0, 0, 0)).toISOString();
      to = new Date(new Date().setHours(8, 0, 0, 0)).toISOString();
    }
    getDashboardTopProducts(from, to);
    //eslint-disable-next-line
  }, [daySelected]);

  useEffect(() => {
    if (products) {
      setLoading(false);
    }
  }, [products]);

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Accordion
      expanded={expanded === "panel1"}
      onChange={handleChange("panel1")}
    >
      <AccordionSummary
        // expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
        className={classes.bgColor}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          style={
            expanded
              ? {
                  height: 50,
                }
              : {
                  height: 100,
                }
          }
        >
          <Grid item>
            <Typography variant="h6" className={classes.headerText}>
              Top Products{" "}
            </Typography>{" "}
          </Grid>{" "}
          <Grid item xs={12}>
            {" "}
            {products && loading === false ? (
              <Fragment>
                {" "}
                {expanded === false ? (
                  <Fragment>
                    {" "}
                    {products.slice(0, 3).map((each, index) => {
                      return (
                        <Grid
                          container
                          direction="row"
                          justifyContent="center"
                          alignItems="flex-end"
                          key={index}
                        >
                          <Grid
                            item
                            style={{
                              width: "6%",
                            }}
                          >
                            <StarIcon
                              style={
                                index === 0
                                  ? {
                                      color: "#ffdd00",
                                      fontSize: 18,
                                    }
                                  : index === 1
                                  ? {
                                      color: "#c0c0c0",
                                      fontSize: 18,
                                    }
                                  : {
                                      color: "#cd7f32",
                                      fontSize: 18,
                                    }
                              }
                            />{" "}
                          </Grid>{" "}
                          <Grid
                            item
                            style={{
                              width: "60%",
                            }}
                            className={classes.headerText}
                          >
                            <Typography variant="subtitle2">
                              {" "}
                              {each.description}{" "}
                            </Typography>{" "}
                          </Grid>{" "}
                          <Grid
                            item
                            style={{
                              width: "17%",
                            }}
                            className={classes.headerText}
                          >
                            <Typography
                              variant="subtitle2"
                              style={{
                                float: "right",
                              }}
                            >
                              ${" "}
                              {each.price.toLocaleString("en", {
                                minimumFractionDigits: 2,
                              })}{" "}
                            </Typography>{" "}
                          </Grid>{" "}
                          <Grid
                            item
                            style={{
                              width: "17%",
                            }}
                            className={classes.headerText}
                          >
                            <Typography
                              variant="subtitle2"
                              style={{
                                float: "right",
                              }}
                            >
                              {each.quantity}{" "}
                            </Typography>{" "}
                          </Grid>{" "}
                        </Grid>
                      );
                    })}{" "}
                  </Fragment>
                ) : null}{" "}
              </Fragment>
            ) : (
              <Grid
                container
                direction="row"
                alignItems="center"
                justifyContent="center"
                style={{
                  height: "80%",
                }}
              >
                <Grid item>
                  <CircularProgress
                    style={{
                      color: "#ffffff",
                    }}
                  />{" "}
                </Grid>{" "}
              </Grid>
            )}{" "}
          </Grid>{" "}
        </Grid>{" "}
      </AccordionSummary>{" "}
      <AccordionDetails>
        {" "}
        {products && loading === false ? (
          <Grid
            container
            direction="row"
            style={{
              height: 300,
            }}
          >
            <Grid
              item
              xs={12}
              style={{
                height: "100%",
              }}
            >
              <Grid
                container
                direction="row"
                alignItems="stretch"
                style={{
                  height: "100%",
                }}
              >
                <Grid
                  item
                  style={{
                    width: "12%",
                  }}
                >
                  <Typography variant="body2">
                    <strong> Code </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "61%",
                  }}
                >
                  <Typography variant="body2">
                    <strong> Description </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "15%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    <strong> Total Order </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  style={{
                    width: "12%",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      float: "right",
                    }}
                  >
                    <strong> Qty </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid item xs={12}>
                  <Divider variant="fullWidth" />
                </Grid>{" "}
                {products.map((each, index) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        style={
                          index % 2 === 0
                            ? {
                                height: "100%",
                                backgroundColor: "#efefef",
                              }
                            : {
                                height: "100%",
                              }
                        }
                      >
                        <Grid
                          item
                          style={{
                            width: "12%",
                          }}
                        >
                          <Typography variant="body2"> {each.sku} </Typography>{" "}
                        </Grid>{" "}
                        <Grid
                          item
                          style={{
                            width: "61%",
                          }}
                        >
                          <Typography variant="body2">
                            {" "}
                            {each.description}{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid
                          item
                          style={{
                            width: "15%",
                          }}
                        >
                          <Typography
                            variant="body2"
                            style={{
                              float: "right",
                            }}
                          >
                            {each.price.toLocaleString("en", {
                              minimumFractionDigits: 2,
                            })}{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid
                          item
                          style={{
                            width: "12%",
                          }}
                        >
                          <Typography
                            variant="body2"
                            style={{
                              float: "right",
                            }}
                          >
                            {each.quantity}{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>
                  );
                })}{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Grid>
        ) : (
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
            style={{
              height: "80%",
            }}
          >
            <Grid item>
              <CircularProgress />
            </Grid>{" "}
          </Grid>
        )}{" "}
      </AccordionDetails>{" "}
    </Accordion>
  );
};

export default TopProducts;
